import { Component, createContext, ReactNode} from 'react';
import { ContextProps, handleContext } from '../react-app-env';

const initialState:ContextProps = {
    step:1,
    handleContext: () => {},
}

const StoreContext = createContext<ContextProps>(initialState);

interface Props { 
    children?:ReactNode
}

class StoreProvider extends Component<Props>{

    state: ContextProps = { ...initialState };
      
    handleContext:handleContext = (key,value,callback) => {
        this.setState(
            { [key] : value }, 
            () => {
                if(callback)
                callback()
                // Persist the state with localstorage
                localStorage.setItem('context',JSON.stringify(this.state))
            }
        );
    }

    render(){
        return(
            <StoreContext.Provider 
                    value = {{
                        ...this.state,
                        handleContext: this.handleContext,
                    }}
                >
                {this.props.children}
            </StoreContext.Provider>
        )
    }
} 

export { StoreContext,StoreProvider }
